// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePharmacyModel {
    static getAttributeTypeMap() {
        return SimpleIntakePharmacyModel.attributeTypeMap;
    }
}
SimpleIntakePharmacyModel.discriminator = undefined;
SimpleIntakePharmacyModel.additionalProperties = false;
SimpleIntakePharmacyModel.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "SimpleIntakeAddressModel"
    },
    {
        "name": "contact",
        "baseName": "contact",
        "type": "SimpleIntakeContactModel"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "phones",
        "baseName": "phones",
        "type": "SimpleIntakePharmacyPhonesModel"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "PharmacyType"
    },
    {
        "name": "specialization",
        "baseName": "specialization",
        "type": "PharmacySpecialization"
    },
];
//# sourceMappingURL=simpleIntakePharmacyModel.js.map